<template>
  <v-row>
    <v-col cols="12" sm="4">
      <v-text-field
        :value="gallons"
        @change="gallonsChanged"
        type="number"
        label="Gallons"
        name="gallons"
        @keydown.native.enter.prevent
        :disabled="disabled"
        reverse
      />
    </v-col>
    <v-col cols="12" sm="4">
      <v-text-field
        :value="ounces"
        @change="ouncesChanged"
        type="number"
        label="Fluid Ounces"
        name="ounces"
        @keydown.native.enter.prevent
        :disabled="disabled"
        reverse
      />
    </v-col>
    <v-col cols="12" sm="4">
      <v-text-field
        :value="weight"
        @change="weightChanged"
        type="number"
        label="Weight (lbs)"
        name="weight"
        @keydown.native.enter.prevent
        :disabled="disabled"
        reverse
      />
    </v-col>
  </v-row>
</template>
<script>
const volumePrecision = 3;
const weightPrecision = 4;

export default {
  props: {
    gallons: {
      type: [String, Number],
      default: 0,
    },
    ounces: {
      type: [String, Number],
      default: 0,
    },
    weight: {
      type: [String, Number],
      default: 0,
    },
    ppg: {
      type: [String, Number],
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    ppg() {
      this.volumeChanged(this.gallons, this.ounces);
    },
  },
  methods: {
    gallonsChanged(value) {
      this.volumeChanged(value, this.ounces);
    },
    ouncesChanged(value) {
      this.volumeChanged(this.gallons, value);
    },
    volumeChanged(gallons, ounces) {
      const parsedGallons = gallons ? parseFloat(gallons, volumePrecision) : 0;
      const parsedOunces = ounces ? parseFloat(ounces, volumePrecision) : 0;
      const totalInGallons = parsedGallons + parsedOunces / 128;
      const weight = totalInGallons * this.ppg;

      this.save(weight, totalInGallons);
    },
    weightChanged(value) {
      if (this.ppg === 0) {
        return;
      }
      const weight = parseFloat(value) || 0;
      const totalInGallons = weight / this.ppg;

      this.save(weight, totalInGallons);
    },
    save(weight, totalInGallons) {
      this.$emit('update:gallons', Math.floor(totalInGallons));
      this.$emit('update:ounces', ((totalInGallons * 128) % 128).toFixed(volumePrecision));
      this.$emit('update:weight', weight.toFixed(weightPrecision));
    },
  },
};
</script>

<style>
.v-text-field__slot {
  input {
    text-align: right;
  }
}
</style>
